import React, { useCallback } from 'react';
import { string, oneOf } from 'prop-types';
import classnames from 'classnames';
import { useFeatureFlags, useGTM } from 'hooks';
import '../QuickFilters.scss';

const QUICKLINKS_CARD_MODE = {
    GRID: 'grid',
    LIST: 'list',
};

export default function QuickLink(props) {
    const [, pushToGTM] = useGTM();
    const {
        buttonClassName,
        className,
        title,
        name,
        quickLink,
        captionTitle,
        mode,
        pictureUrl,
    } = props;

    const [{ isProductCardRedesign }] = useFeatureFlags({
        isProductCardRedesign: 'browsing.new.product.card',
    });

    const rootClassname = classnames(className, 'quickfilters', {
        'quickfilters--grid':
            !isProductCardRedesign || mode === QUICKLINKS_CARD_MODE.GRID,
        'quickfilters--list':
            isProductCardRedesign && mode === QUICKLINKS_CARD_MODE.LIST,
        'quickfilters--background-picture':
            pictureUrl &&
            (!isProductCardRedesign || mode === QUICKLINKS_CARD_MODE.GRID),
    });

    const buttonRootClass = classnames(
        'button quickfilters-button',
        buttonClassName,
    );

    const background =
        pictureUrl && mode === QUICKLINKS_CARD_MODE.GRID
            ? {
                  backgroundImage: `url(${pictureUrl})`,
              }
            : null;

    const handleClick = useCallback(
        event => {
            if (quickLink === 'event:loyalty:showHumanSupport') {
                event.preventDefault();
                pushToGTM({
                    event: 'open_human_support_hub',
                    event_trigger: 'quicklink_card',
                });
                window.dispatchEvent(
                    new Event('loyalty::showHumanSupportModal'),
                );
            }
        },
        [quickLink],
    );

    return (
        <a
            style={background}
            className={rootClassname}
            href={quickLink}
            data-qa="quickFiltersEl"
            onClick={handleClick}
        >
            <div className="quickfilters-text-wrapper">
                {name && <div className="quickfilters-label">{name}</div>}
                <div className="quickfilters-question">{title}</div>
            </div>
            <div className={buttonRootClass} data-qa="quickFiltersCta">
                {captionTitle}
            </div>
        </a>
    );
}

QuickLink.propTypes = {
    className: string,
    buttonClassName: string,
    name: string,
    quickLink: string.isRequired,
    captionTitle: string.isRequired,
    title: string.isRequired,
    mode: oneOf([QUICKLINKS_CARD_MODE.GRID, QUICKLINKS_CARD_MODE.LIST]),
    pictureUrl: string,
};

QuickLink.defaultProps = {
    className: null,
    buttonClassName: null,
    name: null,
    mode: QUICKLINKS_CARD_MODE.GRID,
    pictureUrl: null,
};
